import {
  drawerWidth,
  transition,
  boxShadow,
  defaultFont,
  primaryColor,
  primaryBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  blackColor,
  hexToRgb
} from "../../material-dashboard-react.js";

const sidebarStyle = theme => ({
  drawerPaper: {
    border: "none",
    position: "fixed",
    top: "0",
    bottom: "0",
    left: "0",
    zIndex: "1",
    ...boxShadow,
    width: drawerWidth,
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      position: "fixed",
      height: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      width: drawerWidth,
      ...boxShadow,
      position: "fixed",
      display: "block",
      top: "0",
      height: "100vh",
      right: "0",
      left: "auto",
      zIndex: "1032",
      visibility: "visible",
      overflowY: "visible",
      borderTop: "none",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      transform: `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition
    }
  },
  drawerPaperRTL: {
    [theme.breakpoints.up("md")]: {
      left: "auto !important",
      right: "0 !important"
    },
    [theme.breakpoints.down("sm")]: {
      left: "0  !important",
      right: "auto !important"
    }
  },
  logo: {
    position: "relative",
    padding: "20px 20px",
    zIndex: "4",
    background: "linear-gradient(135deg, rgba(156, 39, 176, 0.15) 0%, rgba(103, 58, 183, 0.15) 100%)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  logoLink: {
    ...defaultFont,
    textTransform: "uppercase",
    padding: "5px 0",
    display: "block",
    fontSize: "20px",
    textAlign: "left",
    fontWeight: "600",
    lineHeight: "30px",
    textDecoration: "none",
    backgroundColor: "transparent",
    "&,&:hover": {
      color: whiteColor
    }
  },
  logoText: {
    fontWeight: "700",
    fontSize: "22px",
    letterSpacing: "0.5px",
    color: whiteColor,
  },
  logoSubtext: {
    display: "block",
    marginTop: "4px",
    fontSize: "11px",
    color: "rgba(" + hexToRgb(whiteColor) + ", 0.6)",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  logoLinkRTL: {
    textAlign: "right"
  },
  logoImage: {
    width: "30px",
    display: "inline-block",
    maxHeight: "30px",
    marginLeft: "10px",
    marginRight: "15px"
  },
  img: {
    width: "35px",
    top: "22px",
    position: "absolute",
    verticalAlign: "middle",
    border: "0"
  },
  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    "&:after": {
      position: "absolute",
      zIndex: "3",
      width: "100%",
      height: "100%",
      content: '""',
      display: "block",
      background: blackColor,
      opacity: ".8"
    }
  },
  list: {
    marginTop: "8px",
    paddingLeft: "0",
    paddingTop: "0",
    paddingBottom: "0",
    marginBottom: "0",
    listStyle: "none",
    position: "unset"
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    "&:hover,&:focus,&:visited,&": {
      color: whiteColor
    }
  },
  itemLink: {
    width: "auto",
    transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
    margin: "4px 12px",
    borderRadius: "8px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    padding: "11px 16px",
    backgroundColor: "transparent",
    ...defaultFont,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      transform: "translateX(4px)",
    }
  },
  itemIconWrapper: {
    minWidth: "40px",
  },
  itemIcon: {
    width: "22px",
    height: "22px",
    fontSize: "22px",
    lineHeight: "22px",
    color: "rgba(" + hexToRgb(whiteColor) + ", 0.75)",
    transition: "all 250ms ease",
  },
  expandIcon: {
    fontSize: "20px",
    color: "rgba(" + hexToRgb(whiteColor) + ", 0.6)",
    transition: "all 250ms ease",
  },
  itemIconRTL: {
    marginRight: "3px",
    marginLeft: "15px",
    float: "right"
  },
  itemText: {
    ...defaultFont,
    margin: "0",
    lineHeight: "22px",
    fontSize: "14px",
    fontWeight: "500",
    color: "rgba(" + hexToRgb(whiteColor) + ", 0.9)",
    transition: "all 250ms ease",
  },
  itemTextRTL: {
    textAlign: "right"
  },
  whiteFont: {
    color: whiteColor + " !important",
    fontWeight: "600 !important",
  },
  nestedList: {
    paddingTop: "0",
    paddingBottom: "8px",
  },
  nestedItemLink: {
    width: "auto",
    transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
    margin: "2px 12px 2px 24px",
    borderRadius: "6px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    padding: "9px 16px 9px 12px",
    backgroundColor: "transparent",
    ...defaultFont,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.06)",
      transform: "translateX(4px)",
    }
  },
  nestedIconWrapper: {
    minWidth: "32px",
  },
  nestedIcon: {
    width: "18px",
    height: "18px",
    fontSize: "18px",
    lineHeight: "18px",
    color: "rgba(" + hexToRgb(whiteColor) + ", 0.65)",
    transition: "all 250ms ease",
  },
  purple: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    boxShadow: "0 2px 8px 0 rgba(102, 126, 234, 0.4)",
    "&:hover,&:focus": {
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      boxShadow: "0 4px 16px 0 rgba(102, 126, 234, 0.5)",
      transform: "translateX(6px)",
    }
  },
  blue: {
    background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    boxShadow: "0 2px 8px 0 rgba(79, 172, 254, 0.4)",
    "&:hover,&:focus": {
      background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      boxShadow: "0 4px 16px 0 rgba(79, 172, 254, 0.5)",
      transform: "translateX(6px)",
    }
  },
  green: {
    background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    boxShadow: "0 2px 8px 0 rgba(67, 233, 123, 0.4)",
    "&:hover,&:focus": {
      background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      boxShadow: "0 4px 16px 0 rgba(67, 233, 123, 0.5)",
      transform: "translateX(6px)",
    }
  },
  orange: {
    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    boxShadow: "0 2px 8px 0 rgba(250, 112, 154, 0.4)",
    "&:hover,&:focus": {
      background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      boxShadow: "0 4px 16px 0 rgba(250, 112, 154, 0.5)",
      transform: "translateX(6px)",
    }
  },
  red: {
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    boxShadow: "0 2px 8px 0 rgba(245, 87, 108, 0.4)",
    "&:hover,&:focus": {
      background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      boxShadow: "0 4px 16px 0 rgba(245, 87, 108, 0.5)",
      transform: "translateX(6px)",
    }
  },
  sidebarWrapper: {
    position: "relative",
    height: "calc(100vh - 75px)",
    overflow: "auto",
    width: "260px",
    zIndex: "4",
    overflowScrolling: "touch"
  },
  activePro: {
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      width: "100%",
      bottom: "13px"
    }
  },
  nested: {
    paddingLeft: theme.spacing(4),
  }
});

export default sidebarStyle;
